import * as yup from 'yup';

export default yup.object({
    file: yup.mixed().required('File is a required field'),
    labels: yup.array().of(yup.string())
});
